import { FC } from 'react';

import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';

import { MapContainer } from '../MapContainer';

import { MapLayout } from './MapLayout';
import { MapPlaceholderContainer } from './internal/components/MapPlaceholder';
import { ToggleMapButtonContainer } from './internal/components/ToggleMapButton';
import { ToggleMapButtonHintContextProvider } from './internal/context/ToggleMapButtonHintContext';

export const MapLayoutContainer: FC = () => {
  const isMapOpen = useListingLayoutIsShortSelector();

  return (
    <ToggleMapButtonHintContextProvider>
      <MapLayout
        isMapOpen={isMapOpen}
        map={<MapContainer />}
        mapPlaceholder={<MapPlaceholderContainer />}
        toggleComponent={<ToggleMapButtonContainer />}
      />
    </ToggleMapButtonHintContextProvider>
  );
};
